export function getDefaultThemeSetting() {
  return { isDarkMode: false };
}

export function getDarkThemeSetting() {
  return { isDarkMode: true };
}
